var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResume = function SvgResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1ZM12.8047 9.53613C12.1402 9.09335 11.2503 9.56975 11.25 10.3682V21.6318C11.2503 22.4303 12.1402 22.9067 12.8047 22.4639L21.252 16.832C21.8456 16.4362 21.8456 15.5638 21.252 15.168L12.8047 9.53613Z",
    fill: "currentColor"
  })));
};
export default SvgResume;